export const DEFAULT_TEASER_TYPE = 'bx-teaser-container--full-width-two-cols'

export type NativeTeaserItem = {
  type: 'native',
  nativeTeaserIndex: number,
  fallback: TeaserItem,
  hasAutoPlay: boolean
}

export type TeaserOrNativeTeaser = NativeTeaserItem | TeaserItem

export function isNativeTeaserItem (teaser: TeaserOrNativeTeaser | undefined | null): teaser is NativeTeaserItem {
  return teaser !== undefined && teaser !== null && 'type' in teaser && teaser.type === 'native'
}
